'use client';

import { Field } from '../../../edit-inventaire/types';
import { EmptyValue } from './empty-value';
import { ImageValue } from './image-value';
import { JsonValue } from './json-value';
import { MultiselectValue } from './multiselect-value';
import { SelectValue } from './select-value';
import { TableValue } from './table-value';
import { TextValue } from './text-value';
import { TextareaValue } from './textarea-value';

interface FieldValueRendererProps {
  field: Field;
  value: any;
  options: { id: string; label: string }[];
}

export function FieldValueRenderer({ field, value, options }: FieldValueRendererProps) {
  // Handle empty values
  if (value === null || value === undefined || value === '') {
    return <EmptyValue />;
  }

  // Handle hidden fields (fields with underscore in name)
  if (field.name.includes('_') && (value === null || value === undefined || value === '')) {
    return null;
  }

  switch (field.type) {
    case 'text':
    case 'number':
      if (field.name.includes('_') && (value === null || value === undefined || value === '')) {
        return null;
      }
      return <TextValue value={value} unit={field.unit} />;

    case 'textarea':
      return <TextareaValue value={value} />;

    case 'multiselect':
      if (field.name.includes('_') && Array.isArray(value) && value.length === 0) {
        return null;
      }
      return <MultiselectValue value={value} options={options} />;

    case 'radio':
    case 'select':
      return <SelectValue value={value} options={options} />;

    case 'table':
      return <TableValue value={value} tableConfig={field.tableConfig} />;

    case 'image-upload':
      return <ImageValue value={value} label={field.label} imageType="arbre" />;

    case 'json':
      return <JsonValue value={value} />;

    default:
      return <span className="text-sm font-semibold text-foreground">{String(value)}</span>;
  }
}

